import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const subscribeNewsletter = async (email, source = "landing") => {
  const res = await axios.post(`${API}/newsletter`, { email, source });
  return res.data;
};
